import { render, staticRenderFns } from "./businesslicense.vue?vue&type=template&id=fa6caf4e&scoped=true"
import script from "./businesslicense.vue?vue&type=script&lang=js"
export * from "./businesslicense.vue?vue&type=script&lang=js"
import style0 from "./businesslicense.vue?vue&type=style&index=0&id=fa6caf4e&prod&lang=scss&scoped=true"
import style1 from "./businesslicense.vue?vue&type=style&index=1&id=fa6caf4e&prod&lang=scss"
import style2 from "./businesslicense.vue?vue&type=style&index=2&id=fa6caf4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6caf4e",
  null
  
)

export default component.exports